module.exports = __webpack_public_path__ + "static/media/user-md-chat.6d40b9fe.svg";